function filterMenu (mapped, term) {
    const filtered = mapped.filter(c => !term || c[0].toLowerCase().startsWith(term.toLowerCase()));
    if (filtered.length > 0) {
        return filtered.sort((a, b) => a[0].localeCompare(b[0]));
    } else {
        return mapped.sort((a, b) => a[0].localeCompare(b[0]));
    }
}

export default filterMenu;